<form
  (submit)="onSubmit()"
>
  <ng-template [ngIf]="!success">
    <div
      fxLayout="column"
      fxLayoutAlign="enter"
    >
      <h2>
        {{ title }}
      </h2>
      <label class="header-label">
        {{ 'contact_form.info' | translate }}
      </label>
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-between center"
      class="contact-info"
    >
      <div
        fxLayout="column"
        fxLayoutAlign="center"
        class="contact-first"
      >
        <mat-input-container>
          <input
            matInput
            [placeholder]="'contact_form.placeholders.first_name' | translate"
            [(ngModel)]="contact.first_name"
            name="firstName"
            required
            #firstName="ngModel"
          >
          <app-form-error [errors]="(firstName.errors && canShowErrors) ? ['nu poate fi gol'] : formError.errors.firstName"></app-form-error>
        </mat-input-container>
        <mat-input-container>
          <input
            matInput
            [placeholder]="'contact_form.placeholders.last_name' | translate"
            [(ngModel)]="contact.last_name"
            name="last_name"
          >
          <app-form-error [errors]="formError.errors.last_name"></app-form-error>
        </mat-input-container>
        <mat-input-container>
          <input
            matInput
            [placeholder]="'contact_form.placeholders.mail' | translate"
            [(ngModel)]="contact.email"
            #email="ngModel"
            name="email"
          >
          <app-form-error [errors]="(email.errors && canShowErrors) ? ['nu poate fi gol'] : formError.errors.email"></app-form-error>
        </mat-input-container>
        <mat-input-container>
          <input
            matInput
            [placeholder]="'contact_form.placeholders.phone' | translate"
            [(ngModel)]="contact.phone"
            name="phone"
            required
            type="tel"
            #phone="ngModel"
          >
          <app-form-error [errors]="(phone.errors && canShowErrors) ? ['nu poate fi gol'] : formError.errors.phone"></app-form-error>
        </mat-input-container>
      </div>
      <div
        fxLayout="column"
        fxLayoutAlign="space-between center"
        class="contact-last"
      >
        <mat-input-container>
          <textarea
            matInput
            [placeholder]="'contact_form.placeholders.message' | translate"
            [(ngModel)]="contact.message"
            name="message"
            #message="ngModel"
          >
          </textarea>
          <app-form-error [errors]="(message.errors && canShowErrors) ? ['nu poate fi gol'] : formError.errors.message"></app-form-error>
        </mat-input-container>
        <mat-checkbox
          [(ngModel)]="contact.marketing_accepted"
          name="cb"
          value="basic_checkbox"
          required
        >
          <span
            [innerHTML]="'contact_form.gdpr.message' | translate"
          >
          </span>
          <a
            target="_blank"
          >
            {{ 'contact_form.gdpr.title' | translate }}
          </a>
        </mat-checkbox>
        <app-form-error [errors]="(formError.errors.marketing_accepted && canShowErrors) ? ['pentru a trimite un mesaj, această bifă este obligatorie.'] : formError.errors.marketing_accepted"></app-form-error>
        <div
          fxLayout="column"
          fxLayoutAlign="space-between center"
        >
          <app-re-captcha
            *ngIf="reCaptchaVersion === 'v2_normal'"
            version="v2_normal"
            #reCaptcha
            (captchaResponse)="onCaptchaResponse($event)"
          ></app-re-captcha>
          <app-form-error [errors]="formError.errors['g-recaptcha-response']"></app-form-error>
          <button
            type="submit"
            mat-raised-button
            color="main-color"
          >
            {{ 'contact_form.submit' | translate }}
          </button>
        </div>
      </div>
    </div>
    <app-re-captcha
      *ngIf="reCaptchaVersion === 'v2_invisible'"
      version="v2_invisible"
      #reCaptcha
      (captchaResponse)="onCaptchaResponse($event)"
    ></app-re-captcha>
    <ng-content></ng-content>
  </ng-template>
  <ng-template [ngIf]="success">
    <h3>
      {{ 'contact_form.success_title' | translate }}
    </h3>
    <p
      [innerHTML]="'contact_form.success_message' | translate"
    >
    </p>
    <button
      mat-raised-button
      color="main-color"
      type="button"
      (click)="success = !success;"
    >
      {{ 'contact_form.success_button' | translate }}
    </button>
  </ng-template>
</form>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/contact-form-base/contact-form-base.component.html